import React, { useEffect, useState } from 'react';
import api, { fmtDateTime } from '@/lib/api';
import { Loading, SectionTitle, EmptyState } from '@/components/Shared';
import { ScrollText } from 'lucide-react';

export default function AdminAudit() {
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get('/admin/audit-logs').then((r) => setLogs(r.data)); }, []);
  if (!logs) return <Loading />;
  return (
    <div className="space-y-4">
      <SectionTitle>Audit Logs</SectionTitle>
      {logs.length === 0 ? <EmptyState title="No audit entries" icon={ScrollText} /> : (
        <div className="rounded-xl border border-border bg-card overflow-x-auto"><table className="w-full text-sm"><thead className="bg-muted/60"><tr className="text-left"><th className="p-3">User</th><th className="p-3">Action</th><th className="p-3">Entity</th><th className="p-3">Old</th><th className="p-3">New</th><th className="p-3">Time</th></tr></thead>
          <tbody>{logs.map((l) => (
            <tr key={l.id} className="border-t border-border"><td className="p-3">{l.user_name} <span className="text-xs text-muted-foreground">({l.user_role})</span></td><td className="p-3"><span className="text-xs rounded-full bg-muted px-2 py-0.5">{l.action}</span></td><td className="p-3">{l.entity_type}</td><td className="p-3 text-xs text-muted-foreground max-w-[120px] truncate">{JSON.stringify(l.old_value)}</td><td className="p-3 text-xs max-w-[120px] truncate">{JSON.stringify(l.new_value)}</td><td className="p-3 text-muted-foreground">{fmtDateTime(l.timestamp)}</td></tr>
          ))}</tbody></table></div>
      )}
    </div>
  );
}
